/** 数据表字段API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/gen/genEntityField';
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Gen.GenEntityField> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 列表查询
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Gen.GenEntityField> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个数据表字段
 *
 * @param id 数据表字段ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Gen.GenEntityField> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存数据表字段
 *
 * @param params 数据表字段信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新数据表字段信息
 *
 * @param params 数据表字段信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除数据表字段
 *
 * @param id 数据表字段ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除数据表字段
 *
 * @param ids 数据表字段ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findAll,
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
